import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";

export function SiteLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-white text-[#0a0b0d]">
            <ScrollToTop />
            <Navbar />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}

export default SiteLayout;
